import { render, staticRenderFns } from "./InventoryBatchPaymentListControl.vue?vue&type=template&id=21d13888&scoped=true"
import script from "./InventoryBatchPaymentListControl.vue?vue&type=script&lang=js"
export * from "./InventoryBatchPaymentListControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d13888",
  null
  
)

export default component.exports